<template>
  <div class="row">

    <b-collapse id="MenuCat">
      <div class="menu-cat">
        <div class="col-lg-12">
          <div class="row">
            <div v-if="!isMobile()" class="col-lg-12">
             <button v-b-toggle.MenuCat class="btn-close mr-c float-right"><img src="/static/images/icons/x.png"/></button>
          </div>
            <div class="col-lg-2">
            </div>
          <div class="col-lg-8">
            <div class="row">
              <div v-for="(categoria,key) in categorias" :value="categoria.value" :key="categoria.value" class="col-lg-4 text-center">
                <button v-b-toggle.MenuCat class="btn-category" :id="'btnCategory'+categoria.id" @click="changeCategory($event,categoria)">{{categoria.nombre}}</button>
                <br v-if="((key+1)/3) % 1 == 0">
              </div>
            </div>
          </div>
          <div v-if="isMobile()" class="col-lg-12">
             <button v-b-toggle.MenuCat class="btn-close"><b-icon icon="x"></b-icon></button>
          </div>
          </div>
        </div>
        
    </div>
    </b-collapse>

    <div class="col-lg-12">
      <div class="container">
          <div class=" search-wrapper" id="">
            <input type="search" id="schArticle" class="search" @input="findByTitle()" @keyup.delete="findByTitle()" placeholder="Buscar un Tema"/>
            <img src="/static/images/icons/search.svg"/>
          </div>
          <h1 class="titulo-categoria">{{titulo_categoria}}</h1>
          <p class="text-categoria">
            {{texto_categoria}}
          </p>
        </div>
    </div>

  </div>
</template>

<script>


import categoriasApi from "../api/categorias";
import {mapActions,mapState} from "vuex"; 


export default {
  name: 'Categorias',
  components: {
  },
  data() {
    return {
      titulo_categoria:"Blog",
      texto_categoria:"Encuentra artículos y publicaciones de los temas más recientes",
      categoria_actual:{categoria:[],btn:null},
      categorias:[],
      timeout:null
    }
  },
  props: {
    msg: String
  },
  computed: {
    ...mapState("posts",['categoria_id','titulo'])
  },
  methods: {
    ...mapActions("posts", ["setPostsByCategory","setPostsByTitle"]),
    getCategorias(){
      /*
      -PARAMETROS PERMITIDOS-
        nombre=conta
        activo=true
        paginate=true
        items_to_show=10
        order=asc
        order_by=id
        -------------------------*/

      let parametros = {activo: true,paginate:true,items_to_show:10,order:"asc",order_by:"id"};
      categoriasApi
      .getCategorias(parametros)
      .then(response => {
        this.categorias = response.data.data;
      }).catch(err => {
        console.log("Ocurrio un error al cargar las categorías.");
      });
    },

    changeCategory(e, categoria){
      let btn = e.target;
      
      this.texto_categoria = categoria.descripcion;
      this.titulo_categoria = categoria.nombre;

      if(this.categoria_actual.btn != null)
      this.categoria_actual.btn.classList.remove("active");

      this.categoria_actual.categoria = categoria;
      this.categoria_actual.btn = btn;
      
      btn.classList.add('active');

      clearTimeout(this.timeout);
      document.getElementById("schArticle").value = "";
      this.setPostsByTitle("");
      
      this.setPostsByCategory(categoria.id);
      
    },

    findByTitle(e){
      var title = document.getElementById("schArticle").value;

      if(title.length > 2){
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.setPostsByTitle(title);
          //clearTimeout(this.timeout);
        },1000);
         
      }else{
        clearTimeout(this.timeout);
        this.setPostsByTitle("");
      }
      
      
     
    },

    isMobile(){
      var check = false;
      //console.log(window.screen.width);
      if(window.screen.width < 769){
        return check=true;
      }
    }
  },
  mounted () {
    this.getCategorias();
  },
}
</script>

<style scoped>
  .menu-cat{
    width: 100%;
    background: #FFFFFF;
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    padding-top:8%;
    padding-bottom: 20px;
    z-index: 1029;
   -webkit-box-shadow: 0 0 7px rgba(0, 0, 0, 0.1) !important;
    -moz-box-shadow: 0 0 7px rgba(0, 0, 0, 0.1) !important;
    box-shadow: -2px 0 12px 2px rgba(0, 0, 0, 0.2);
  }
  
  .search-wrapper {
  -webkit-box-align: center;
  -webkit-align-items: center;
      -ms-flex-align: center;
          align-items: center;
  display: -webkit-inline-box;
  display: -webkit-inline-flex;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-flex-flow: row-reverse nowrap;
      -ms-flex-flow: row-reverse nowrap;
          flex-flow: row-reverse nowrap;
  width:30%;
}
.search-wrapper .search::placeholder { 
  color:#BDBDBD; 
  } 

.search-wrapper .search {
  background-color: #FFFFFF;
  border:  3px solid #F2F2F2;
  border-radius: 50px;
  align-items: center;
  text-align: center;
  padding: .6rem .5rem;
  font-family: 'Muli';
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 25px;
  -webkit-transition: border-color .2s ease;
  transition: border-color .2s ease;
  width: 100%;
}

.search-wrapper .search + img {
  margin-right: -13%;
  height: 10%;
}
.search-wrapper .search:focus {
  border-color: #999;
  outline: none;
}
.search-wrapper .search:focus + img {
  border-color: #999;
}

  #myBtn {
    display: none;
    position: fixed;
    bottom: 20px;
    right: 30px;
    z-index: 99;
    font-size: 18px;
    border: none;
    outline: none;
    background-color: red;
    color: white;
    cursor: pointer;
    padding: 15px;
    border-radius: 4px;
  }

  #myBtn:hover {
    background-color: #555;
  }

  /**
  * DIVIDERS
  */
  .divider-01 {
    height: 5px;
    width: 16%;
    background-color: #E8404E;
    border-radius: 3px;
    margin-left: auto;
    margin-right: auto;
  }

  .btn-category{
    padding: 8px 37px 8px 37px;
    background: #FFFFFF;
    border: 0.5px solid #2DB9D1;
    border-radius: 100px;
    background: #FFFFFF;
    box-shadow: 1px 3px 5px rgba(107, 127, 153, 0.2);
    border-radius: 25px;
    font-family: Muli;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 18px;
    align-items: center;
    letter-spacing: 0.1px;
    color:#BDBDBD; 
    margin: 10px;
  }

  .btn-category.active{
    color: #2DB9D1;
  }

  button.btn-category:hover{
    color: #2DB9D1;
  }

  .btn-close{
    border: 1px solid #00d0f5;
    border-radius: 100px;
    color:#FFFFFF;
    box-shadow: 1px 3px 5px rgba(107, 127, 153, 0.2);
    border-radius: 25px;
    font-family: Muli;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 18px;
    align-items: center;
    letter-spacing: 0.1px;
    transition-duration: 0.3s;  
    background-color: #2DB9D1;
    border-radius: 150px;
    padding: 1px;
    
  }

  .btn-close img{
    width: 40px;
  }

  .mr-c{
    margin-right: 5%;
  }

   button.btn-close:hover{
    background: #00d0f5;
    transition-duration: 0.3s;
  }


  .titulo-categoria{
    font-family: Muli;
    font-style: normal;
    font-weight: 800;
    font-size: 50px;
    line-height: 70px;
    align-items: center;
    text-align: center;
    letter-spacing: 0.2px;
    color: #2DB9D1;
    margin-top:90px;
    margin-bottom:60px;
  }

  .text-categoria{
    font-family: Muli;
    font-style: normal;
    font-weight: normal;
    font-size: 32px;
    line-height: 40px;
    text-align: center;
    color: #1E2245;
  }

  .bg-categoria {
    background: url("/static/images/bg_azul_categoria.svg") repeat-x;
  }

  .titulo_articulos {
    font-family: Muli;
    font-style: normal;
    font-weight: normal;
    font-size: 32px;
    line-height: 40px;
    align-items: center;
    text-align: center;

    color: #1E2245;
    padding-bottom: 40px;
  }

  .texto_articulos {
    font-family: Muli;
    font-style: normal;
    font-size: 18px;
    line-height: 22px;
    text-align: center;
    letter-spacing: 0.2px;color: #1E2245;
    padding-bottom:40px;
  }


  @media(max-width: 768px){
    .menu-cat{
   
    padding-top:20%;
   
  }
    .search-wrapper {
      width:100%;
    }
    .search-wrapper .search + img {
      margin-right: -15%;
    }

    .titulo-categoria{
    font-family: Muli;
    font-style: normal;
    font-weight: 800;
    font-size: 40px;
    line-height: 70px;
    align-items: center;
    text-align: center;
    letter-spacing: 0.2px;
    color: #2DB9D1;
    margin-top:90px;
    margin-bottom:60px;
  }
  .text-categoria{
    font-family: Muli;
    font-style: normal;
    font-weight: 600;
    font-size: 28px;
    line-height: 35px;
    text-align: center;
    color: #1E2245;
    }
  }

  @media only screen and(max-width: 30%) {
    #demo {
      display: none;
    }
  }
</style>
